/* eslint-disable */
import MainTitle from '../../components/MainTitle'
import { NavLink } from 'react-router-dom'
import CardButton from '../../components/CardButton'
import useAuth from '../../hooks/useAuth'
import { useState, useEffect } from 'react'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Pagination from '../../components/Pagination'
import {
  faTrashCan,
  faMagnifyingGlass,
  faEye,
  faPlus,
  faSort,
  faSortUp,
  faSortDown,
  faCheckCircle,
  faReply,
} from '@fortawesome/free-solid-svg-icons'
import Modal from '../../components/Modal'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import SessionExtensionSlideOut from '../../components/SessionExtensionSlideOut'

function SessionExtension() {
  const axios = useAxiosPrivate()
  const navigate = useNavigate()
  const { setShowLoader, showLoader, can, createInfo, auth } = useAuth()

  const [notifications, setNotifications] = useState([])
  const [deleteNotification, setDeleteNotification] = useState({})
  const [showModal, setShowModal] = useState(false)

  const [assignUser, setAssignUser] = useState({})
  const [selectedNotification, setSelectedNotification] = useState({})
  const [selectedUser, setSelectedUser] = useState({})
  const [replies, setReplies] = useState([])
  const [reply, setReply] = useState({ reason: '' })
  const [notes, setNotes] = useState([])

  const [search, setSearch] = useState('')

  const [statusFilter, setStatusFilter] = useState('')
  const [currentRecords, setCurrentRecords] = useState([])
  const [filteredRecords, setFilteredRecords] = useState([])
  const [nPages, setNumberOfPages] = useState(0)
  const [viewNotification, setViewNotification] = useState(false)
  const [notificationData, setNotificationData] = useState({})
  const [open, setOpen] = useState(false)
  const [showReply, setShowReply] = useState(false)

  const [currentPage, setCurrentPage] = useState(1)
  // No of Records to be displayed on each page
  const [recordsPerPage] = useState(10)

  const [completedCount, setCompletedCount] = useState(0)
  const [totalRefferrals, setTotalRefferals] = useState(0)
  const [viewType, setViewType] = useState('active');
  const [completedExtensionsCount, setCompletedExtensionsCount] = useState(0)

  const [indexOfLastRecord, setIndexOfLastRecord] = useState(10)
  const [indexOfFirstRecord, setIndexOfFirstRecord] = useState(0)

  const [modalTitle, setModalTitle] = useState('')
  const [dropdownValue, setDropdownValue] = useState('')

  const [originalRecords, setOriginalRecords] = useState([])
  const [columnClickCounts, setColumnClickCounts] = useState({})
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'ascending',
  })

  const [statusOptions, setStatusOptions] = useState([])

  const getExpiryBadge = (expiryDate) => {
    const now = moment()
    if (!expiryDate) return null
    const expiry = moment(expiryDate)

    const diffInDays = expiry.diff(now, 'days')
    const diffInWeeks = expiry.diff(now, 'weeks')

    if (expiry.isBefore(now, 'day')) {
      return (
        <span className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm">
          Expired
        </span>
      )
    }

    if (diffInDays <= 7) {
      return (
        <span className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm">
          Expires in {diffInDays} Day{diffInDays !== 1 ? 's' : ''}
        </span>
      )
    }

    if (diffInWeeks < 5) {
      return (
        <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm">
          Expires in {diffInWeeks} Week{diffInWeeks !== 1 ? 's' : ''}
        </span>
      )
    }

    return null
  }

  const viewClient = (clientId, claimId = null, sessionId = null) => {
    if (sessionId) {
      navigate(`/clients/${clientId}/claims/${claimId}/sessions/${sessionId}`)
    } else {
      navigate(`/clients/${clientId}`)
    }
  }

  const formatDate = (dateString) => {
    return moment(dateString).format('DD/MM/YYYY')
  }

  const sortArray = (array, key, direction) => {
    return [...array].sort((a, b) => {
      const aValue = getNestedValue(a, key)
      const bValue = getNestedValue(b, key)

      if (aValue == null && bValue != null)
        return direction === 'ascending' ? 1 : -1
      if (aValue != null && bValue == null)
        return direction === 'ascending' ? -1 : 1
      if (aValue == null && bValue == null) return 0

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return direction === 'ascending'
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue)
      }

      return direction === 'ascending' ? aValue - bValue : bValue - aValue
    })
  }

  const getNestedValue = (obj, path) => {
    if (!path || typeof path !== 'string') return undefined
    return path.split('.').reduce((acc, part) => acc?.[part], obj)
  }

  const renderSortArrow = (columnKey) => {
    if (sortConfig.key === columnKey) {
      if (sortConfig.direction === 'ascending') {
        return <FontAwesomeIcon icon={faSortUp} />
      } else {
        return <FontAwesomeIcon icon={faSortDown} />
      }
    }
    return <FontAwesomeIcon icon={faSort} />
  }

  const handleSort = (key) => {
    let newColumnClickCounts = { ...columnClickCounts }
    if (!newColumnClickCounts[key]) {
      newColumnClickCounts[key] = 1
    } else {
      newColumnClickCounts[key]++
    }

    if (newColumnClickCounts[key] === 3) {
      setSortConfig({
        key: null,
        direction: 'descending',
      })
      newColumnClickCounts[key] = 0
      setCurrentRecords(
        originalRecords.slice(indexOfFirstRecord, indexOfLastRecord)
      )
    } else {
      let direction =
        sortConfig.direction === 'ascending' ? 'descending' : 'ascending'
      setSortConfig({ key, direction })

      const sortedRecords = sortArray(originalRecords, key, direction)
      setCurrentRecords(
        sortedRecords.slice(indexOfFirstRecord, indexOfLastRecord)
      )
    }
    setColumnClickCounts(newColumnClickCounts)
  }

  const nextPage = () => {
    if (currentPage < nPages) {
      const newPage = currentPage + 1
      const indexFirst = newPage * recordsPerPage - recordsPerPage
      const indexLast = newPage * recordsPerPage

      setIndexOfFirstRecord(indexFirst)
      setIndexOfLastRecord(indexLast)
      setCurrentPage(newPage)

      const sortedRecords = sortArray(
        filteredRecords,
        sortConfig.key,
        sortConfig.direction
      )
      setCurrentRecords(sortedRecords.slice(indexFirst, indexLast))
    }
  }

  const previousPage = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1
      const indexFirst = (newPage - 1) * recordsPerPage
      const indexLast = newPage * recordsPerPage

      setIndexOfFirstRecord(indexFirst)
      setIndexOfLastRecord(indexLast)
      setCurrentPage(newPage)

      const sortedRecords = sortArray(
        originalRecords,
        sortConfig.key,
        sortConfig.direction
      )
      setCurrentRecords(sortedRecords.slice(indexFirst, indexLast))
    }
  }

  const handleSearch = (e) => {
    const searchValue = e.target.value.trim().toLowerCase()
    setSearch(searchValue)

    const indexFirst = 0
    const indexLast = recordsPerPage
    setCurrentPage(1)
    setIndexOfFirstRecord(indexFirst)
    setIndexOfLastRecord(indexLast)

    let filtered = notifications

    if (searchValue.length > 0) {
      filtered = filtered.filter(
        (e) =>
          e.title?.toLowerCase().includes(searchValue) ||
          e.meta?.clinician_name?.toLowerCase().includes(searchValue) ||
          e.meta?.client_name?.toLowerCase().includes(searchValue) ||
          e.meta?.status?.toLowerCase().includes(searchValue) ||
          e.meta?.client_reference?.toLowerCase().includes(searchValue)
      )
    }

    if (statusFilter) {
      filtered = filtered.filter(
        (e) => e.meta?.status?.toLowerCase() === statusFilter
      )
    }

    setFilteredRecords(filtered)
    setCurrentRecords(filtered.slice(indexFirst, indexLast))
    setNumberOfPages(Math.ceil(filtered.length / recordsPerPage))

    setSortConfig({
      key: null,
      direction: 'descending',
    })
  }

  useEffect(() => {
    if(auth?.token) {
        getNotifications()   
    }
}, [statusFilter, auth?.token, viewType])

  const getNotifications = async () => {
    try {

      setShowLoader(true)
      const response = await axios.get('/notifications/session-extension')

      const { extensions, replies, count, completed } = response.data.result

      const uniqueStatuses = [
        ...new Set(
          extensions
            .map((n) => n.meta?.status?.trim())
            .filter((s) => s && s !== '')
        ),
      ]
      
      if (viewType !== 'completed'){
        setTotalRefferals(count)
      }
      setCompletedCount(completed)
      setStatusOptions(uniqueStatuses)
      let filteredNotifications = extensions
      if (statusFilter) {
        filteredNotifications = extensions.filter(
          (notification) =>
            notification.meta?.status?.toLowerCase() === statusFilter
        )
      }
      setNotifications(filteredNotifications)
      setReplies(replies)
      setOriginalRecords(filteredNotifications)
      setFilteredRecords(filteredNotifications)
      setCurrentRecords(
        filteredNotifications.slice(indexOfFirstRecord, indexOfLastRecord)
      )
      setNumberOfPages(Math.ceil(filteredNotifications.length / recordsPerPage))
    } catch (error) {}
    setShowLoader(false)
  }

  

  const deleteNotificationClicked = (notification) => {
    setDeleteNotification(notification)
    setModalTitle(`Mark ${notification.title} as Completed?`)
    setShowModal(true)
  }

  const resetFilters = () => {
    setStatusFilter('')
    setDropdownValue('')
    setSearch('')
    setFilteredRecords(originalRecords)
    setCurrentRecords(originalRecords.slice(0, recordsPerPage))
    setCurrentPage(1)
    setIndexOfFirstRecord(0)
    setIndexOfLastRecord(recordsPerPage)
    setSortConfig({
      key: null,
      direction: 'descending',
    })
  }

  const resetModal = (resetNotifications = true) => {
    setDeleteNotification({})
    setAssignUser({})
    setNotificationData({})
    setSelectedNotification({})
    setSelectedUser({})
    setShowModal(false)
    setShowReply(false)
    setViewNotification(false)
    if (resetNotifications) {
      setNotifications(notifications)
    }
  }

  const ModalBody = () => {
    if (showReply) {
      return <ReplyElement />
    }

    if (deleteNotification.id) {
      return <DeleteNotificationElement />
    }

    if (viewNotification) {
      return <ViewNotificationElement />
    }

    if (assignUser) {
      return <AssignUserElement />
    }
  }

  const assignUserClicked = (data) => {
    setAssignUser({})
    setSelectedNotification(data)
    setModalTitle(
      `Add Sessions to ${data.meta.client_reference ?? data.meta.client_id}`
    )
    setShowModal(true)
  }

  const viewNotificationClicked = (data) => {
    setNotificationData(data)
    setNotes(data.meta?.notes || [])
    setOpen(true)
  }

  const handleStatusUpdate = () => {
    getNotifications()
  }

  const handleStatusChange = (e) => {
    const value = e.target.value
    setStatusFilter(value)
    setDropdownValue(value)

    const indexFirst = 0
    const indexLast = recordsPerPage
    setCurrentPage(1)
    setIndexOfFirstRecord(indexFirst)
    setIndexOfLastRecord(indexLast)

    let filtered = notifications

    if (value !== '') {
      filtered = filtered.filter((n) => n.meta?.status?.toLowerCase() === value)
    }

    if (search.trim() !== '') {
      const s = search.trim().toLowerCase()
      filtered = filtered.filter(
        (n) =>
          n.title?.toLowerCase().includes(s) ||
          n.meta?.clinician_name?.toLowerCase().includes(s) ||
          n.meta?.client_name?.toLowerCase().includes(s) ||
          n.meta?.status?.toLowerCase().includes(s) ||
          n.meta?.client_reference?.toLowerCase().includes(s)
      )
    }

    setFilteredRecords(filtered)
    setCurrentRecords(filtered.slice(indexFirst, indexLast))
    setNumberOfPages(Math.ceil(filtered.length / recordsPerPage))

    setSortConfig({
      key: null,
      direction: 'descending',
    })
  }

  const isFilterApplied = () => {
    return statusFilter !== '' || search !== ''
  }

  const replyClicked = (data) => {
    setReply({})
    setShowReply(true)
    setSelectedNotification(data)
    setModalTitle(`Reply to this request ${data.title}`)
    setShowModal(true)
  }

  const AssignUserElement = () => {
    const assignUserSubmit = async (e) => {
      e.preventDefault()
      setShowLoader(true)

      try {
        const data = {
          id: selectedNotification.meta.claim_id,
          session_id: selectedNotification.meta.session_id,
          notification_id: selectedNotification.id,
          sessions: selectedNotification.meta.sessions_required,
          reason: 'Approved by Extension Request',
        }

        const response = await axios.post(
          `/claims/${selectedNotification.meta.claim_id}/extra-sessions`,
          data
        )
        if (!response.data.error) {
          createInfo('success', `Successfully Added Sessions`)
          getNotifications()
        }
        resetModal()
      } catch (error) {
        console.log(error)
      }

      setShowLoader(false)
    }

    return (
      <form onSubmit={assignUserSubmit}>
        <div className="mb-3">
          <div>
            {selectedNotification.meta.client_reference} has completed{' '}
            <span className="font-semibold">
              {selectedNotification.meta.sessions_completed}
            </span>{' '}
            sessions.
          </div>
          <div>
            You are adding{' '}
            <span className="font-semibold">
              {selectedNotification.meta.sessions_required}
            </span>{' '}
            more sessions.
          </div>
        </div>
        <div className="flex mt-2 w-full">
          <button type="submit" className="btn mt-4 mr-4 w-1/2">
            Add Sessions
          </button>
          <button
            type="button"
            className="btn red mt-4 w-1/2"
            onClick={resetModal}
          >
            Cancel
          </button>
        </div>
      </form>
    )
  }

  const ViewNotificationElement = () => {
    return (
      <div>
        <div className="mb-3">
          <p className="space-y-1">
            <div>
              {' '}
              <div className="font-medium">Title: </div>
              <span className="text-slate-600">{notificationData.title}</span>
            </div>
            <div className="pb-4">
              <div className="font-medium">Description: </div>
              <span className="text-slate-600">{notificationData.body}</span>
            </div>
            <div className="grid grid-cols-2 space-y-1">
              <div>
                <div className="font-medium">Client Reference: </div>
                <span className="text-slate-600">
                  {notificationData.meta?.client_reference}
                </span>
              </div>
              <div>
                <div className="font-medium">Claim Reference: </div>
                <span className="text-slate-600">
                  {notificationData.meta?.claim_reference}
                </span>
              </div>
              <div>
                <div className="font-medium">Request Date: </div>
                <span className="text-slate-600">
                  {formatDate(notificationData.meta?.requested_at)}
                </span>
              </div>
              <div>
                <div className="font-medium">Requested By: </div>
                <span className="text-slate-600">
                  {notificationData.created}
                </span>
              </div>
              {notificationData.meta?.reason_for_extension && (
                <div>
                  <div className="font-medium">Extension Reason: </div>
                  <span className="text-slate-600">
                    {notificationData.meta?.reason_for_extension ?? ''}
                  </span>
                </div>
              )}
              {notificationData.meta?.hasOwnProperty('is_insured') && (
                <div>
                  <div className="font-medium">Is Insured:</div>
                  <span className="text-slate-600">
                    {notificationData.meta.is_insured ? 'Yes' : 'No'}
                  </span>
                </div>
              )}
              {notificationData.meta?.policy_end_date && (
                <div>
                  <div className="font-medium">Policy Expiry: </div>
                  <span className="text-slate-600 pr-2">
                    {formatDate(notificationData.meta?.policy_end_date) ?? ''}
                  </span>
                  <span className="text-xs">
                    {getExpiryBadge(notificationData.meta.policy_end_date)}
                  </span>
                </div>
              )}
              {notificationData.meta?.session_id && (
                <div className="flex items-center justify-between col-span-2">
                  <div>
                    <div className="font-medium">Session ID: </div>
                    <span className="text-slate-600">
                      {notificationData.meta?.session_id}
                    </span>
                  </div>
                  <div className="w-1/2">
                    <div className="font-medium">Session Date Created: </div>
                    <span className="text-slate-600">
                      {formatDate(notificationData.meta?.session_date)}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </p>
          <div className="flex mt-2 w-full">
            {notificationData.meta?.session_id ? (
              <button
                onClick={() =>
                  viewClient(
                    notificationData.meta?.client_id,
                    notificationData.meta?.claim_id,
                    notificationData.meta?.session_id
                  )
                }
                className="btn mt-4 mr-4 w-1/2"
              >
                <span>View Session</span>
              </button>
            ) : (
              <button
                onClick={() => viewClient(notificationData.meta?.client_id)}
                className="btn mt-4 mr-4 w-1/2"
              >
                <span>View Client</span>
              </button>
            )}

            <button
              type="button"
              className="btn red mt-4 w-1/2"
              onClick={resetModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    )
  }

  const DeleteNotificationElement = () => {
    const deleteNotificationFn = async (e) => {
      e.preventDefault()
      setShowLoader(true)
      resetModal(false)
      try {
        await axios.get('/notifications/delete/' + deleteNotification.id)
        createInfo(
          'success',
          `Completed Notification: ${deleteNotification.title}`
        )

        setCurrentRecords(
          currentRecords.filter((notification) => {
            return notification.id !== deleteNotification.id
          })
        )
        setNotifications(
          notifications.filter((notification) => {
            return notification.id !== deleteService.id
          })
        )

        setShowLoader(false)
      } catch (error) {
        setShowLoader(false)
      }
    }

    return (
      <form onSubmit={deleteNotificationFn}>
        <div className="mb-3">
          <p className="text-lg font-bold my-8 text-center">
            Are you sure you want to mark this notification as completed?
          </p>
          <div className="flex mt-2 w-full">
            <button className="btn green mt-4 mr-4 w-1/2">Complete</button>

            <button
              type="button"
              className="btn red mt-4 w-1/2"
              onClick={resetModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    )
  }

  const ReplyElement = () => {
    const relatedReplies = replies.filter(
      (r) =>
        r.meta?.original_notification_id === selectedNotification.id &&
        r.type === 'System Update'
    )

    const replySubmit = async (e) => {
      e.preventDefault()
      setShowLoader(true)
      try {
        const response = await axios.post(`/notifications/create`, {
          body: reply.reason,
          area: 'Admin',
          type: 'System Update',
          meta: {
            ...selectedNotification.meta,
            original_notification_id: selectedNotification.id,
            original_user_id: selectedNotification.created_by,
          },
          user_id: selectedNotification.created_by,
          title: `Response to Admin Request for Client ${selectedNotification.meta.client_reference}`,
        })

        createInfo('success', `Successfully created response`)
        getNotifications()
        resetModal(false)
      } catch (error) {
        console.log(error)
      }

      setShowLoader(false)
    }

    return (
      <form onSubmit={replySubmit}>
        <div className="mb-4">{selectedNotification.body}</div>
        {relatedReplies?.length > 0 && (
          <div className="mb-4 border rounded-md p-2 bg-gray-50">
            <div className="text-sm font-semibold mb-2 text-gray-800">
              Previous Replies:
            </div>
            {relatedReplies.map((reply, index) => (
              <div key={index} className="mb-2 border-b pb-2 last:border-b-0">
                <div className="text-sm text-gray-700 whitespace-pre-line">
                  {reply.body}
                </div>
                <div className="text-xs text-gray-500 mt-1">
                  {new Date(reply.created_at).toLocaleString()}
                </div>
              </div>
            ))}
          </div>
        )}
        <div className="mb-3">
          <div className="text-sm text-gray-700">Reply:</div>
          <textarea
            className="border rounded-md w-full p-2"
            rows="3"
            defaultValue={reply.reason}
            onChange={(e) => (reply.reason = e.target.value)}
          ></textarea>
        </div>

        <div className="flex mt-2 w-full">
          <button
            type="submit"
            className="btn mt-4 mr-4 w-1/2"
            disabled={showLoader}
          >
            {showLoader ? 'Sending...' : 'Send'}
          </button>
          <button
            type="button"
            className="btn red mt-4 w-1/2"
            onClick={resetModal}
          >
            Cancel
          </button>
        </div>
      </form>
    )
  }


  return (
    <section>
      {showModal && (
        <Modal title={modalTitle} body={<ModalBody />} show={resetModal} />
      )}
      <MainTitle title="Session Extension Requests" />

      <section>
        {showModal && (
          <Modal title={modalTitle} body={<ModalBody />} show={resetModal} />
        )}
        <ul className="flex just-between flex-wrap">
          {can('create notifications') && (
            <li className="w-1/4 mb-6 mr-3">
              <NavLink to="new">
                <CardButton icon={faPlus} title="Create New Notification" />
              </NavLink>
            </li>
          )}
          <button onClick={() => setViewType('active')} className="rounded-md bg-white shadow h-20 w-1/4 px-4 mb-6 flex flex-col justify-center items-start mr-3">
            
            <h2 className="font-bold">Total Requests</h2>
            <p className="text-3xl font-black">{totalRefferrals}</p>
          </button>
          <button
             className="rounded-md bg-red-100 shadow h-20 w-1/4 px-4 mb-6 flex flex-col justify-center items-start mr-3"
             onClick={() => setViewType('completed')}
          >
            <h2 className="font-bold">Completed Requests</h2>
            <p className="text-3xl font-black">{completedCount}</p>
          </button>
        </ul>
      </section>
      <div className="flex justify-between ">
        <div className="py-4">
          <div className="relative mt-1">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                onClick={handleSearch}
              />
            </div>
            <input
              type="text"
              id="table-search"
              onChange={handleSearch}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-80 pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Search Requests"
            />
          </div>
        </div>
        <div className="py-4">
          <select
            onChange={handleStatusChange}
            value={dropdownValue}
            className="px-4 py-2 border border-gray-300 rounded-md shadow-md mr-2"
          >
            <option value="">Filter by Status</option>
            {statusOptions.map((option) => (
              <option key={option} value={option.toLowerCase()}>
                {option}
              </option>
            ))}
          </select>
          {isFilterApplied() && (
            <button
              onClick={resetFilters}
              className="bg-red-500 text-white rounded-lg px-4 py-2 ml-4"
            >
              Reset Filters
            </button>
          )}
        </div>
      </div>
      <table className="table-main">
        <thead>
          <tr>
            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('meta.client_reference')}
            >
              Client Reference {renderSortArrow('meta.client_reference')}
            </th>
            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('meta.client_name')}
            >
              Client Name {renderSortArrow('meta.client_name')}
            </th>
            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('meta.clinician_name')}
            >
              Counsellor Name {renderSortArrow('meta.clinician_name')}
            </th>
            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('meta.sessions_completed')}
            >
              Sessions Completed {renderSortArrow('meta.sessions_completed')}
            </th>
            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('meta.sessions_required')}
            >
              Sessions Required {renderSortArrow('meta.sessions_required')}
            </th>
            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('meta.dna_sessions')}
            >
              DNA/Cancellation Session {renderSortArrow('meta.dna_sessions')}
            </th>
            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('meta.status')}
            >
              Status {renderSortArrow('meta.status')}
            </th>
            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('created_at')}
            >
              Created At {renderSortArrow('created_at')}
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody className="table-main">
          {currentRecords.length > 0 ? (
            currentRecords.map((notification) => {
              return (
                <tr key={notification.id}>
                  <td>{notification.meta.client_reference}</td>
                  <td>{notification.meta.client_name}</td>
                  <td>{notification.meta.clinician_name}</td>
                  <td>{notification.meta.sessions_completed}</td>
                  <td>{notification.meta.sessions_required}</td>
                  <td>{notification.meta.dna_sessions}</td>
                  <td className="w-1/6" style={{ padding: 0 }}>
                    {notification.meta?.status && (
                      <span
                        className={`px-3 py-1 rounded-full text-white text-sm font-medium capitalize
                          ${
                            notification.meta.status === 'pending' || notification.meta.status === 'school funding requested' || notification.meta.status === 'further information requested'
                              ? 'bg-orange-500'
                              : notification.meta.status === 'approval requested' || notification.meta.status === 'schools mutual approval requested' 
                              ? 'bg-green-500'
                              : notification.meta.status === 'policy expired' || notification.meta.status === 'awaiting renewal'
                              ? 'bg-red-500'
                              : 'bg-blue-500'
                          }`}
                      >
                        {notification.meta.status}
                      </span>
                    )}
                  </td>
                  <td>
                    {moment(notification.created_at).format('DD/MM/YYYY')}
                  </td>
                  <td>
                    <div className="flex justify-center space-x-2">
                      <span
                        title="View"
                        onClick={() => viewNotificationClicked(notification)}
                        className="flex justify-center items-center bg-blue-400 rounded-md text-blue-800 h-9 w-12 hover:bg-blue-500 cursor-pointer"
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </span>
                      {viewType !== 'completed' && (<span
                        title="Add Sessions"
                        onClick={() => assignUserClicked(notification)}
                        className="flex justify-center items-center bg-green-400 rounded-md text-green-800 h-9 w-12 hover:bg-green-500 cursor-pointer"
                      >
                        <FontAwesomeIcon icon={faCheckCircle} />
                      </span>)}
                      {viewType !== 'completed' && (
                        <>
                      <span
                        title="Reply"
                        onClick={() => replyClicked(notification)}
                        className="flex justify-center items-center bg-pink-400 rounded-md text-pink-800 h-9 w-12  hover:bg-pink-500 cursor-pointer"
                      >
                        <FontAwesomeIcon icon={faReply} />
                      </span>
                      <span
                        title="Delete"
                        onClick={() => deleteNotificationClicked(notification)}
                        className="flex justify-center items-center bg-red-400 rounded-md text-red-800 h-9 w-12  hover:bg-red-500 cursor-pointer"
                      >
                        <FontAwesomeIcon icon={faTrashCan} />
                      </span>
                      </>)}
                    </div>
                  </td>
                </tr>
              )
            })
          ) : (
            <tr>
              <td colSpan={9}>
                <p className="no-records">No notifications found</p>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <Pagination
        next={nextPage}
        prev={previousPage}
        first={indexOfFirstRecord}
        last={indexOfLastRecord}
        total={filteredRecords.length}
      />

      <SessionExtensionSlideOut
        open={open}
        setOpen={setOpen}
        notificationData={notificationData}
        onStatusUpdate={handleStatusUpdate}
        replies={replies}
        updateNotificationData={setNotificationData}
      />
    </section>
  )
}

export default SessionExtension
